import RegisterKomship from './RegisterKomship.vue'

export default RegisterKomship
